import React from 'react';
import './Brands.css';

const BrandCarousel = () => {
  const brands = [
    { id: 1, name: 'Exide', image: '/assets/exide-logo.png' },
    { id: 2, name: 'Torque', image: '/assets/TORQUE.png' },
    { id: 3, name: 'Amaron', image: '/assets/amaron-logo.png' },
    { id: 4, name: 'Luminous', image: '/assets/luminous-logo.png' }
  ];

  return (
    <div className="brand-section">
      <div className="brand-container">
        <h2 className="brand-title">OUR BRAND</h2>
        
        <div className="brand-carousel-wrapper">
          <div className="brand-carousel">
            {brands.map(brand => (
              <div key={brand.id} className="brand-item">
                <img src={brand.image} alt={brand.name} />
              </div>
            ))}
            {brands.map(brand => (
              <div key={`${brand.id}-dup`} className="brand-item">
                <img src={brand.image} alt={brand.name} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrandCarousel;